import styled from "styled-components";

export const Root = styled.div`
  user-select:none;
  position: relative;
  width: 100%;
  height: 100%;
  overflow:auto;
`;
